<template>
  <div class="loading-symbol-container">
    <div class="loading-symbol" v-bind:style="{'background-image': 'url(./static/loading_wave.svg'}"></div>
  </div>
</template>

<script>
export default {
  name: "Loading",
  props: [
    'isLoading'
  ]
}
</script>

<style scoped lang="scss">
  .loading-symbol-container {
    background-color: $black;
    border-radius: 4px;
    padding: 8px 10px;
  }

  .loading-symbol {
    background-repeat: repeat-x;
    width: 100%;
    height: 10px;
    animation: move-horizontally 80s;
  }

  @keyframes move-horizontally {
    0% { background-position: 0 0; }
    50% { background-position: -1000% 0; }
  }
</style>
